import script from "./MBotaoSelecionar.vue?vue&type=script&lang=ts&setup=true"
export * from "./MBotaoSelecionar.vue?vue&type=script&lang=ts&setup=true"

import "./MBotaoSelecionar.vue?vue&type=style&index=0&id=12217a96&lang=scss"

const __exports__ = script;

export default __exports__